import './index.scss';

import React, {useEffect, useContext, useState} from 'react';
import {marked} from 'marked';

import {Context} from '../../context/dataStore';

const BandLayout = ({metaData, metaData_OrgName}) => {
  const {getReminderDescription, dispatch, state: {reminderData}} = useContext(Context);
  const [whichid, setPageId] = useState('bandformat')
  const pageUrl = 'https://mycb-local.collegeplanning-nonprod.collegeboard.org:3000/';
  useEffect(() => {
    onLoad();
    if(window.location.href===pageUrl || window.location.href.includes('modulepage') || window.location.href.includes('degreesofferred')) {
      setPageId('bandformat2')
    }
  }, []);
  useEffect(() => {
    reminderData?.forEach(el=> {
      if(el.code===`${metaData}`) {
        document.getElementById('reminderHeader').innerHTML = el.is_displayed===false?
        document.getElementById('banddiv').style.display = 'none':
        marked(`${el.value}`)
      }
    });
  }, [reminderData]);

  const onLoad = async() => {
    const result = await getReminderDescription();
    dispatch({type: 'UPDATE_REMINDER', payload: result.data.data});
  };

  return(
    <div className='cb-band cb-band-hero cb-band-hero-bg bandContainer' id='banddiv'>
      <div id={`${whichid}`} style={{width:(window.location.href)!==pageUrl? '90% !important' : 'inherit !important'}}>
        <div role='region' aria-label='Instutional Information' className='cb-band-hero-content cb-white-color'>
              <h1 id='metadaOrgname'>{metaData_OrgName?metaData_OrgName:'Welcome'}</h1>
              <div className='bandContainer_header' id='reminderHeader' />
        </div>
      </div>
    </div>
  );
};

export default BandLayout;